import React from 'react'
import { CocktailList } from '../CocktailList/CocktailList'

export const Form = ({cocktail,text,setText,handleSubmit,showId}) => {

  return (
    <div className=' mt-10 flex flex-col justify-center items-center'>
     <form action='submit' className="w-full max-w-sm" onSubmit={handleSubmit}>
      <div className="flex items-center border-b border-teal-500 py-2  w-200">

       <input 
        className="appearance-none bg-transparent border-none w-full text-gray-700 mr-3 py-1 px-2 leading-tight focus:outline-none text-center"
        type="text"
        value={text} 
        placeholder="type here..." 
        aria-label="Full name"
        onChange={(e)=> setText(e.target.value)}
        />

        <button 
        className="flex-shrink-0 bg-teal-500 hover:bg-teal-700 border-teal-500 hover:border-teal-700 text-sm border-4 text-white py-1 px-2 rounded" 
        type="submit"
        >
        Search
        </button>

      </div>
     </form>

     <div className=' flex mt-10'>
       {cocktail?.length>0 && <CocktailList cocktail={cocktail} showId={showId}/>}
       {cocktail === null && <p>❌No cocktails available with this name❌</p>}
     </div>
    </div>
  )
}
